import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'
import { GlobalModalHeader } from 'components/shared/Modal/styles'
import { fadeInOnRender } from 'styles/animations'

export const StyledTreatmentDetailsModal = styled(Box)`
    ${GlobalModalHeader} {
        @media ${respondAbove.xl} {
            box-shadow: 0 7px 20px 0 rgba(0, 0, 0, 0.07);
        }
    }
`

export const ModalBodyWrapper = styled(Box)`
    background: ${({ theme }) => theme.colors.grayscale_200};
    padding: 24px 16px;

    @media ${respondAbove.md} {
        padding: 40px;
    }
`

export const ContentWrapper = styled(Box)`
    max-width: 100%;
    ${fadeInOnRender};
`

export const VariantWrapper = styled(Box)`
    width: 100%;
    background: ${({ theme }) => theme.colors.grayscale_0};
    padding: 16px;
    border-radius: 5px;

    @media ${respondAbove.md} {
        padding: 16px;
    }
`
